export enum ActionStatus {
  SUCCESS = 'success',
  ERROR = 'error',
}
